import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { CheckboxGroup, CheckboxGroupViewList } from ".";
import { strings } from "../../resources";

const TreatmentCheckboxList = ({
  mode,
  data,
  groupName,
  checkboxOptions,
  header,
  errorFields,
  handleCheckboxGroupChange,
  handleNestedChange
}) => {
  const isEditMode = mode === "edit" || mode === "create";
  const child = "other"; // The child field allows additional details to be entered when "other" is selected
  const childName = `${groupName}_${child}`;
  const childData = data?.[groupName]?.[child];
  const hasError = errorFields?.includes(groupName);
  const hasOtherError = errorFields?.includes(childName);
  
  return isEditMode ? (
    <>
      <CheckboxGroup
        groupClassName=""
        checkboxClassName=""
        mode={mode}
        error={hasError}
        label={header}
        required
        group={groupName}
        data={data}
        handleCheckboxChange={handleCheckboxGroupChange}
        options={checkboxOptions}
      />
      {childData?.checked && (
          <Form.TextArea
            error={hasOtherError}
            className="treatmentOther groupChild"
            label={strings.form.label.otherDetails}
            name={childName}
            group={groupName}
            child={child}
            onChange={handleNestedChange}
            placeholder={strings.form.placeholder.details}
            required
            value={data?.[childName] || ""}
            rows={2}
          />
        )}
    </>
  ) : (
    <div className="treatmentViewList">
      <Form.Field>
        <label>
          <span>{header}</span>
        </label>
      </Form.Field>
      <CheckboxGroupViewList
        name={groupName}
        value={data[groupName]}
        prefix=""
        noItemsText="No items found"
        mapping
      />
    </div>
  );
};

TreatmentCheckboxList.propTypes = {
  mode: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  groupName: PropTypes.string.isRequired,
  checkboxOptions: PropTypes.array.isRequired,
  header: PropTypes.string.isRequired,
  errorFields: PropTypes.array.isRequired,
  handleCheckboxGroupChange: PropTypes.func.isRequired,
  handleNestedChange: PropTypes.func.isRequired
};

export default TreatmentCheckboxList;
